module.exports = __webpack_public_path__ + "img/quinta-do-piloto.f57d8618.jpg";